export default __webpack_public_path__ + "static/media/caseSlide1.ab507cf3.png";